import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button, Form } from 'react-bootstrap'
import { FaRegSquarePlus } from "react-icons/fa6";
import * as yup from 'yup';
import { useFormik } from 'formik';
import toast from 'react-hot-toast'
import { getCategoryListing } from '../../api/context/category'
import imageToBase64 from 'image-to-base64/browser';
import moment from 'moment';
import { BiSolidEditAlt } from "react-icons/bi";
import CreateSubCategory from './CreateSubCategory'
import { createSubCategory, deleteSubCategory, editSubCategory, getSubCategoryListing, getSubCategoryListingPaginate, statusSubCatUpdate, vtoStatusSubCatUpdate } from '../../api/context/subcategory';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { MdDelete, MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { IoMdArrowBack } from "react-icons/io";
import { checkUserPermissions } from '../../helpers/permission';
import Loader from '../../components/loader/loader';
import ReactPaginate from 'react-paginate';
import { getCategoryListingPaginate } from '../../api/context/manufacturer';
import { Switch } from '@mui/material';


const customStyles = {
    control: (provided) => ({
        ...provided,
        border: "1px solid #a7a7a7",
        padding: '6px',
    }),
};

const SubCategories = () => {

    const [show, setShow] = useState(false);

    const { state } = useLocation();

    const subcat = state?.data?.title;

    const { id } = useParams();

    const navigate = useNavigate();

    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);
    const [category, setCategory] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    // Inside your component
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");

    const [dataCount, setDataCount] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 8;


    const toggleModal = () => {
        setModal(!modal);
    };

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedCategory(null);
    };

    const validationSchema = yup.object().shape({
        subCategoryId: yup
            .string('Enter your Category')
            .trim()
            .required('Category is required'),
        title: yup
            .string('Enter your firstName')
            .trim()
            .required('Title is required'),
        desc: yup
            .string('Enter your lastName')
            .trim()
            .required('Description is required'),
        img: selectedCategory?.id ? yup.string().nullable() : yup.string().required('Image is required'),
        isActive: yup
            .boolean()
            .required('isActive is required'),
        sizes: yup
            .array()
            .test('unique', 'Sizes must be unique', function (value) {
                if (!value) return true; // if array is empty or undefined
                return new Set(value).size === value.length;
            }),
        sizeTypes: yup
            .array()
            .test('unique', 'Size types must be unique', function (value) {
                if (!value) return true;
                return new Set(value).size === value.length;
            }),
        parameters: yup
            .array()
            .test('unique', 'Parameters must be unique', function (value) {
                if (!value) return true;
                return new Set(value).size === value.length;
            }),
    });

    const formik = useFormik({
        initialValues: {
            subCategoryId: '',
            selectedCategory: '',
            subSubCategoryId: '',
            title: '',
            desc: '',
            sizes: [],
            sizeTypes: [],
            parameters: [],
            img: '',
            img_view: '',
            isActive: true
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {


            const hasDuplicateSizeTypes = new Set(
                values.sizeTypes.map(i => typeof i.sizeType === 'string' ? i.sizeType.toLowerCase() : i.sizeType)
            ).size !== values.sizeTypes.length;

            const hasDuplicateSizes = new Set(
                values.sizes.map(i => typeof i.size === 'string' ? i.size.toLowerCase() : i.size)
            ).size !== values.sizes.length;

            const hasDuplicateParameters = new Set(
                values.parameters.map(i => typeof i.parameter === 'string' ? i.parameter.toLowerCase() : i.parameter)
            ).size !== values.parameters.length;

            if (hasDuplicateSizeTypes) {
                toast.error('Size types contain duplicate values (case insensitive)!');
                return;
            }
            if (hasDuplicateSizes) {
                toast.error('Sizes contain duplicate values (case insensitive)!');
                return;
            }
            if (hasDuplicateParameters) {
                toast.error('Parameters contain duplicate values (case insensitive)!');
                return;
            }

            setLoading(true);
            if (values.img == '') {
                delete values.img;
            }
            delete values.img_view;
            if (selectedCategory?.id) {
                editSubCategory(values)((response) => {
                    console.log(values, 'values are');

                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Sub Category Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedCategory(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createSubCategory(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Sub Category Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedCategory(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }
        },
    });

    let typingTimer;
    const loadOptionsCategory = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 3) {
                    getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        console.log(response)
                        if (response?.statusCode == 200) {
                            console.log(response?.results)
                            resolve(response?.results);
                            setCategory(response?.results)
                        } else {
                        }
                    })
                }
                else {
                    resolve([]);
                }

            }, 300);
        });
    };

    const onCategoryChange = (selectedOption) => {
        console.log(selectedOption, 'selectedOption');
        formik.setValues({
            ...formik.values,
            subCategoryId: selectedOption ? selectedOption.value : '',
            selectedCategory: selectedOption,
        });
    };

    const handleImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            img: response,
            img_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const getAllSubCategories = (page, limit) => {
        getSubCategoryListingPaginate({ id, page, limit })((response) => {
            if (response?.statusCode == 200) {
                setSubCategory(response?.data?.subSubCategory);
                setDataCount(response?.data?.totalCount)
                setLoading(false);
            } else {
                setLoading(false);
                // Handle error condition
            }
        });
    };

    const handlePageChange = (selectedPage) => {
        getAllSubCategories(selectedPage.selected + 1, itemsPerPage)
        setCurrentPage(selectedPage.selected);
    };

    // const getAllCategories = () => {
    //     getCategoryListing()((response) => {
    //         if (response?.statusCode == 200) {
    //             setCategory(response?.data?.subcategories);
    //         } else {
    //             // Handle error condition
    //         }
    //     });
    // };


    const handleEditClick = (category) => {
        console.log(category, 'category is true');
        console.log(category?.SubSubCategorySizeTypes?.length, 'category is true');
        setSelectedCategory(category);
        formik.setValues({
            ...formik.values,
            subSubCategoryId: category?.id ?? '',
            selectedCategory: {
                value: category?.Subcategory?.id ? category?.Subcategory?.id : '',
                label: category?.Subcategory?.title ? category?.Subcategory?.title : ''
            },
            subCategoryId: category?.subcategoryId ?? '',
            title: category?.title ?? '',
            desc: category?.description ?? '',
            sizes: category?.SubSubcategorySizes?.length > 0
                ? category.SubSubcategorySizes.map(i => ({ size: i.size }))
                : [],
            sizeTypes: category?.SubSubCategorySizeTypes?.length > 0
                ? category.SubSubCategorySizeTypes.map(i => ({ sizeType: i.sizeType }))
                : [],
            parameters: category?.SubSubcategoryParameters?.length > 0
                ? category.SubSubcategoryParameters.map(i => ({ parameter: i.parameter }))
                : [],
            // img: category?.img ?? '',
            img_view: category?.img ?? '',
            isActive: category?.isActive ?? true
        });
        setShow(true);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    }

    const handleSubCatProducts = (subcatId) => {
        navigate('/sub-categories-products/' + subcatId)
    }

    const statusActive = (id) => {
        // Store current state for potential rollback
        const previousSubCategories = [...subcategory];

        // Optimistically update UI immediately
        setSubCategory(prevSubCategories =>
            prevSubCategories.map(item =>
                item.id === id
                    ? { ...item, isActive: !item.isActive }
                    : item
            )
        );

        // Then make API call
        statusSubCatUpdate(id)((response) => {
            if (response?.data?.statusCode !== 200) {
                // Revert if API call fails
                setSubCategory(previousSubCategories);
                toast.error("Failed to update status");
            }
            // No need to call setUpdate(!update) anymore
        });
    }

    const vtoStatusActive = (id) => {
        const previousSubCategories = [...subcategory];

        setSubCategory(prevSubCategories =>
            prevSubCategories.map(item =>
                item.id === id
                    ? { ...item, isAllowedForVTO: !item.isAllowedForVTO }
                    : item
            )
        );

        vtoStatusSubCatUpdate(id)((response) => {
            if (response?.data?.statusCode !== 200) {
                setSubCategory(previousSubCategories);
                toast.error("Failed to update VTO status");
            }
        });
    }

    const deleteSubCategories = (id) => {
        deleteSubCategory(id)((response) => {
            if (response?.data?.statusCode == 200) {
                const updatedCount = dataCount - 1;
                setDataCount(updatedCount);
                // setUpdate(!update);
                setModal(!modal);
                // Check if we need to navigate back a page
                const totalPages = Math.ceil(updatedCount / itemsPerPage);
                if (currentPage >= totalPages && currentPage > 0) {
                    // Go back to the previous page
                    setCurrentPage(currentPage - 1);
                    getAllSubCategories(currentPage, itemsPerPage);
                } else {
                    // Stay on the same page and refetch data
                    getAllSubCategories(currentPage + 1, itemsPerPage);
                }
            } else {

            }
        });

    }

    useEffect(() => {
        setLoading(true);
        getAllSubCategories(1, itemsPerPage)
    }, [update]);

    useEffect(() => {
        // getAllCategories()
        getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                console.log(response?.results)
                setCategory(response?.results)
            } else {
            }
        })
    }, []);

    console.log(formik, 'formik');


    return (
        <>
            <div>

                <div className="row">
                    <div className="col-12">


                        <div className="d-flex justify-content-between align-items-stretch mb-3">
                            <div className="d-flex align-items-center">
                                <Link to='/categories' className='me-3 text-dark'>
                                    <IoMdArrowBack className='fs-3 text-black' />
                                </Link>
                                <h3 className="mb-0 fw-bolder">{subcat} Sub Categories</h3>
                            </div>

                            {checkUserPermissions('manage_sub_category') ? (
                                <div className="d-flex align-items-center pe-4">
                                    <div className='shadow-none d-flex align-items-center'>
                                        <Button
                                            className='request_btn ms-2'
                                            onClick={() => navigate(`/create-sub-categories`, {
                                                state: {
                                                    categoryId: id,
                                                    categoryName: subcat,
                                                }
                                            })}
                                            style={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <FaRegSquarePlus className='me-2' />
                                            Add New SubCategory
                                        </Button>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className='d_grid_wrapper' style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                            gap: '3px',
                            padding: '10px 0'
                        }}>
                            {loading ? (
                                <div style={{ height: '60vh' }}>
                                    <Loader />
                                </div>
                            ) : (
                                <>
                                    {subcategory?.length > 0 ? (
                                        subcategory.map((data, index) => (
                                            <div className='card_wrapper shadow-sm ' style={{
                                                border: "1px solid #d1d1d1" // light black/gray border
                                            }} key={index}>
                                                {checkUserPermissions('manage_sub_category') && (
                                                    <div className='icon_flex_wrapper'>
                                                        <div className='icon_wrapper' onClick={() => navigate(`/create-sub-categories/${data.id}`, {
                                                            state: {
                                                                subCategoryData: data
                                                            }
                                                        })}
                                                        >
                                                            <BiSolidEditAlt className='icon' />
                                                        </div>
                                                        <div className='icon_wrapper' onClick={() => handleConfirm(data?.id)}>
                                                            <MdDelete className='icon' />

                                                        </div>
                                                    </div>
                                                )}


                                                <div className='card_img_wrapper'>
                                                    <img src={data?.img} className='card_img img-fluid' alt={data?.title} />
                                                </div>
                                                <div className='card_content_wrapper'>
                                                    <div className='title_wrap'>
                                                        <h3>{data?.title}</h3>
                                                    </div>
                                                    <div className='contents'>
                                                        <p dangerouslySetInnerHTML={{ __html: data?.description }} />
                                                    </div>
                                                    <div className='created_on'>
                                                        <h5>Created on</h5>
                                                        <h5>{moment(data?.createdAt).format("DD/MM/YYYY")}</h5>
                                                    </div>
                                                    {checkUserPermissions('manage_sub_category') && (
                                                        <div className='status_wrap'>
                                                            <div className='title'>Status</div>
                                                            <div className="d-flex justify-content-center">
                                                                <Switch
                                                                    size="20px"
                                                                    id={`custom-switch-${index}`}
                                                                    checked={data?.isActive}
                                                                    onChange={() => statusActive(data?.id)}
                                                                    className="custom-switch"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {checkUserPermissions('manage_sub_category') && (
                                                        <div className='status_wrap'>
                                                            <div className='title'>VTO Status</div>
                                                            <div className="d-flex justify-content-center">
                                                                <Switch
                                                                    size="20px"
                                                                    id={`vto-switch-${index}`}
                                                                    checked={data?.isAllowedForVTO}
                                                                    onChange={() => vtoStatusActive(data?.id)}
                                                                    className="custom-switch"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className='col-lg-12'>
                                            <p className='no-data' style={{ fontSize: '16px', paddingTop: '50px', paddingBottom: '50px', textAlign: "center" }}>
                                                No Sub Categories Found
                                            </p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                        {subcategory?.length > 0 && Math.ceil(dataCount / itemsPerPage) > 1 && (
                            <ReactPaginate
                                pageCount={Math.ceil(dataCount / itemsPerPage)}
                                previousLabel={<MdOutlineKeyboardArrowLeft fontSize={24} color='#CECECE' />}
                                nextLabel={<MdOutlineKeyboardArrowRight fontSize={24} color='#CECECE' />}
                                onPageChange={handlePageChange}
                                containerClassName="pagination"
                                activeClassName="active"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                disabledClassName="disabled"
                            />
                        )}
                    </div>
                    {/* <CreateSubCategory show={show} handleClose={handleClose} handleShow={handleShow} formik={formik} handleImageChange={handleImageChange} category={category} selectedCategory={selectedCategory} loading={loading} customStyles={customStyles} onCategoryChange={onCategoryChange} loadOptionsCategory={loadOptionsCategory} /> */}
                    <CustomisedModal
                        isOpen={modal}
                        customClass={"policy_modal"}
                        toggle={toggleModal}
                    >
                        <h5>
                            Are you sure you want to remove this item?
                        </h5>
                        <div className="policy_Agree">
                            <Button
                                onClick={() => {
                                    setModal(!modal);
                                }}
                                size="lg"
                                className='btn_cancel'
                            >
                                Cancel
                            </Button>
                            <Button
                                size="lg"
                                className='btn'
                                onClick={() => deleteSubCategories(deletingId)}
                            >
                                Remove
                            </Button>
                        </div>
                    </CustomisedModal>
                </div>
            </div>
        </>
    )
}

export default SubCategories